<template>
  <div id="app">
    <template v-if="WhiteliRtroutes.includes($route.path)||WhiteliRtrouteName.includes($route.name)">
      <router-view></router-view>
    </template>
    <template v-else>
      <IndexComponent></IndexComponent>
    </template>
    <!-- Cookie同意弹窗 -->
    <CookieConsentBanner />
    <!-- 将弹窗放在App级别，确保它在banner之上 -->
    <CookiePreferencesModal 
      v-if="showPreferences"
      :visible="showPreferences"
      @close="closePreferences"
    />
  </div>
</template>

<script>
// import IndexComponent from './components/IndexComponent.vue'
import IndexComponent from '@/layout/index.vue'
import CookieConsentBanner from '@/components/CookieConsent/CookieConsentBanner.vue';
import CookiePreferencesModal from '@/components/CookieConsent/CookiePreferencesModal.vue';
import { mapState, mapActions } from "vuex";
export default {
  components: { IndexComponent, CookieConsentBanner, CookiePreferencesModal },
  data() {
    return {
      WhiteliRtroutes: ['/', "/login", "/404", '/userAgreement', '/privacyPolicy', '/i18nUpload','/Register','/RegisterAccomplish',],
      WhiteliRtrouteName:['screen', 'advancedPreview']
    }
  },
  computed: {
    ...mapState('cookie', ['showPreferences'])
  },
  created() {
    // 获取服务语言
    this.$store.dispatch('setLanguage', localStorage.getItem('Accept-Language') || 'en-US');
    // 监听浏览器的visibilitychange事件，当页面从隐藏变为可见时检查Token
    this.handleVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        const currentToken = window.localStorage.getItem("newToken") || '';
        this.onTokenChange(currentToken);
      }
    };
    
    document.addEventListener('visibilitychange', this.handleVisibilityChange);
  },
  beforeDestroy() {
    if (this.handleVisibilityChange) {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    }
  },
  methods: {
    ...mapActions("token", ["onTokenChange", "closePreferences"]),
  },
}

</script>
<style lang="scss">
@import "~@/styles/element-variables.scss";
body {
  font-size: 16px;

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  hr,
  p,
  blockquote,
  dl,
  dt,
  dd,
  ul,
  ol,
  li,
  pre,
  form,
  fieldset,
  legend,
  button,
  input,
  textarea,
  th,
  td {
    margin: 0;
    padding: 0;
  }

  ul,
  li {
    list-style: none;
  }

  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
		'Noto Color Emoji';
  color: #333;
}

* {
  box-sizing: border-box;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-radius: 5px;
  background-color: #ebeef5;
}

::-webkit-scrollbar-thumb {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #ccc;
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: rgba(255, 255, 255, 1);
}

.el-menu-vertical-demo:not(.el-menu--collapse) {
  width: 200px;
  min-height: 400px;
  background: $--common-background-color;
}

.el-dialog__header {
  background-color: #F8F8F8;
}

// .el-pager li {
//   background: #F1F3F3 !important;
//   color: #409EFF;

// }

/**
    高亮
  */
// .el-pager li:not(.disabled).active {
//   // background-color: #be0897 !important;
//   color: #409EFF !important;
// }
</style>
